'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash.clonedeep');

var _lodash2 = _interopRequireDefault(_lodash);

var _redux = require('redux');

var _product = require('../actions/product');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_FILTER = {
    status: -1,
    type: -1,
    keyword: ''
};
var filter = function filter() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_FILTER;
    var action = arguments[1];

    switch (action.type) {
        case _product.FILTER_PRODUCTS:
            return Object.assign({}, state, action.filter);
        default:
            return state;
    }
};

var INITIAL_STATE = {
    isFetching: false,
    didInvalidate: false,
    items: [],
    pagination: {}
};
var products = function products() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];

    switch (action.type) {
        case _product.INVALIDATE_PRODUCTS:
            return _extends({}, state, {
                didInvalidate: true
            });
        case _product.REQUEST_PRODUCTS:
            return _extends({}, state, {
                isFetching: true,
                didInvalidate: false
            });
        case _product.RECEIVE_PRODUCTS:
            return _extends({}, state, {
                isFetching: false,
                didInvalidate: false,
                items: action.products,
                lastUpdated: action.received_at,
                pagination: action.pagination
            });
        case _product.FAILURE_PRODUCTS:
            return _extends({}, state, {
                isFetching: false,
                error: action.error
            });
        default:
            return state;
    }
};

var productReducer = (0, _redux.combineReducers)({
    products: products,
    filter: filter
});

exports.default = productReducer;


//////////////////
// WEBPACK FOOTER
// ./src/js/reducers/product.js
// module id = 874
// module chunks = 0